import { createFileRoute } from '@tanstack/react-router'
import { BuildPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'

export const Route = createFileRoute('/builds/$buildSlug')({
  loader: ({ params }) =>
    loadPageData({ data: { kind: 'build', locale: 'en', params } }),
  head: ({ loaderData }) => loaderData?.head ?? {},
  component: RouteComponent,
})

function RouteComponent() {
  const { buildSlug } = Route.useParams()
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <BuildPage buildSlug={buildSlug} />
    </CatalogProvider>
  )
}
